import QuickHookPage from './QuickHookPage/QuickHookPage';
import QuickHookGenPage from './QuickHookGenPage/QuickHookGenPage';

export default {
  QuickHookPage,
  QuickHookGenPage,
};
